const state = {
  rootFont: "",
  headingsFont: "",
  headingOneCase: "",
  headingTwoCase: "",
  headingThreeCase: "",
};

const mutations = {
  setRootFont(state, payload) {
    state.rootFont = payload;
  },
  setHeadingsFont(state, payload) {
    state.headingsFont = payload;
  },
  setHeadingOneCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingOneCase = "uppercase";
    }
    else{
      state.headingOneCase = "lowercase"
    }
  },
  setHeadingTwoCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingTwoCase = "uppercase";
    }
    else{
      state.headingTwoCase = "lowercase"
    }
  },
  setHeadingThreeCase(state, payload) {
    if (payload || typeof payload === "undefined") {
      state.headingThreeCase = "uppercase";
    }
    else{
      state.headingThreeCase = "lowercase"
    }
  },
  capitalizeHeadingOne(state, payload){
    if(payload){
      state.headingOneCase = "capitalize"
    }
  },
  capitalizeHeadingTwo(state, payload){
    if(payload){
      state.headingTwoCase = "capitalize"
    }
  },
  capitalizeHeadingThree(state, payload){
    if(payload){
      state.headingThreeCase = "capitalize"
    }
  },
  

};

const actions = {
  setRootFont({ commit }, payload) {
    commit("setRootFont", payload);
  },
  setHeadingsFont({ commit }, payload) {
    commit("setHeadingsFont", payload);
  },
  headingOneCase({ commit }, payload) {
    commit("setHeadingOneCase", payload);
  },
  headingTwoCase({ commit }, payload) {
    commit("setHeadingTwoCase", payload);
  },
  headingThreeCase({ commit }, payload) {
    commit("setHeadingThreeCase", payload);
  },
  headingOneCapitalize({commit}, payload){
    commit("capitalizeHeadingOne", payload);
  },
  headingTwoCapitalize({commit}, payload){
    commit("capitalizeHeadingTwo", payload)
  },
  headingThreeCapitalize({commit}, payload){
    commit("capitalizeHeadingThree", payload)
  }
};

const getters = {
  rootFont(state) {
    return state.rootFont;
  },
  headingsFont(state) {
    return state.headingsFont;
  },
  headingOneCase(state) {
    return state.headingOneCase;
  },
  headingTwoCase(state) {
    return state.headingTwoCase;
  },
  headingThreeCase(state) {
    return state.headingThreeCase;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/fonts.js